import { render, staticRenderFns } from "./FileInputClearing.vue?vue&type=template&id=0a80346a&"
import script from "./FileInputClearing.vue?vue&type=script&lang=js&"
export * from "./FileInputClearing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports